export default __webpack_public_path__ + "78b173374a9e727a23474e1ddaffe745.svg";